import { useRouter } from "next/router"
import { Container } from "@octopus-energy/coral/atoms"
import { storyblokEditable } from "@storyblok/react"
import { Typeform } from "@/components/atoms"
import { type SbBlokTypeform } from "../types"

const TRACKING_KEY_MAP = {
    utm_campaign: "utmCampaign",
    utm_content: "utmContent",
    utm_medium: "utmMedium",
    utm_source: "utmSource",
    utm_term: "utmTerm",
    gclid: "gclid",
} satisfies Record<string, keyof SbBlokTypeform>

interface DynamicTypeformProps {
    blok: SbBlokTypeform
}

export function DynamicTypeform({ blok }: DynamicTypeformProps) {
    const router = useRouter()
    const trackingSearchParams = new URLSearchParams()

    Object.entries(TRACKING_KEY_MAP).forEach(([queryKey, blokKey]) => {
        const queryValue = router.query[queryKey]
        const isTrackingTagEnabled = blok[blokKey]

        if (typeof queryValue !== "string" || !isTrackingTagEnabled) {
            return
        }

        trackingSearchParams.set(queryKey, queryValue)
    })

    return (
        <Container
            paddingBottom="xxxl"
            attributes={{
                id: blok.id,
                "data-testid": `${blok._uid}`,
            }}
        >
            <Typeform
                {...storyblokEditable(blok)}
                id={blok.id}
                domain={blok.domain}
                iframeProps={{ title: blok.title }}
                tracking={Object.fromEntries(trackingSearchParams)}
                autoResize
                hideFooter
                inlineOnMobile
            />
        </Container>
    )
}

export default DynamicTypeform
